import React from 'react';
import './InvoiceDetails.css'

const InvoiceDetails = ({ invoiceInfo, setInvoiceInfo }) => {
  return (
    <div className="InvoiceForm__invoice-details-section">
      <div className="InvoiceForm__invoice-fields-row">
        <div className="InvoiceForm__field-group">
          <label htmlFor="invoiceNumber" className="InvoiceForm__field-label">
            Invoice Number
          </label>
          <input
            id="invoiceNumber"
            type="text"
            className="InvoiceForm__input"
            placeholder="Invoice Number *"
            value={invoiceInfo.number}
            required
            onChange={e => setInvoiceInfo({ ...invoiceInfo, number: e.target.value })}
          />
        </div>
        <div className="InvoiceForm__field-group">
          <label htmlFor="issueDate" className="InvoiceForm__field-label">
            Issue Date
          </label>
          <input
            id="issueDate"
            type="date"
            className="InvoiceForm__input"
            placeholder="Issue Date"
            value={invoiceInfo.issueDate}
            onChange={e => setInvoiceInfo({ ...invoiceInfo, issueDate: e.target.value })}
          />
        </div>
        <div className="InvoiceForm__field-group">
          <label htmlFor="dueDate" className="InvoiceForm__field-label">
            Due Date
          </label>
          <input
            id="dueDate"
            type="date"
            className="InvoiceForm__input"
            placeholder="Due Date"
            value={invoiceInfo.dueDate}
            onChange={e => setInvoiceInfo({ ...invoiceInfo, dueDate: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetails;
